exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common_button {\n  font-weight: 600;\n  letter-spacing: 2px;\n  padding: 10px 16px;\n  color: var(--text-dark-blue);\n  border: 2px solid var(--primary-dark-blue);\n  text-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-radius: 20px !important;\n  text-transform: uppercase;\n  background-color: transparent;\n  transition: 0.2s ease-in;\n  -o-transition: 0.2s ease-in;\n  -ms-transition: 0.2s ease-in;\n  -moz-transition: 0.2s ease-in;\n  -webkit-transition: 0.2s ease-in; }\n  .common_button:hover {\n    color: #fff;\n    background-color: var(--primary-dark-blue); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/commonButton.scss
// module id = 1545
// module chunks = 0